import { PropertyData } from '../../../models';

export class BaseAddOnComponent {

  constructor() { }

  public setClass(item: PropertyData, index: number = 0): string {
    if (item.MainElementList[index].Disabled)
      return 'q-bo-disabled';
    if (item.MainElementList[index].InValid)
      return 'q-bo-novalid';
    if (item.MainElementList[index].Required)
      return 'q-bo-required';
    return '';
  }

  getId(item: PropertyData): string {
    return item && item.MainElementList && item.MainElementList.length > 0 ? item.MainElementList[0].ID : '';
  }
}
